import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-well-being',
  templateUrl: './well-being.component.html',
  styleUrls: ['./well-being.component.css']
})
export class WellBeingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
